// LPPLWEBMOB-728
export const getConfig = async () => {
  try {
    const appDataDefaultURL =
      "https://" +
      window.location.hostname +
      "/" +
      window.location.pathname.split("/")[1] +
      "/" +
      "appData.json";
    const result = await fetch(appDataDefaultURL, {
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => response.json());

    if (result.config.apiPostalCodesAndModelsEndpoint) {
      const apiPostalCodesAndModelsEndpoint =
        result.config.apiPostalCodesAndModelsEndpoint;
      return { apiPostalCodesAndModelsEndpoint };
    } else {
      throw new Error(
        "Invalid appData.json format. Missing config or apiEndpoint."
      );
    }
  } catch (error) {
    throw new Error(`Error fetching appData.json, ${error}`);
  }
};
